import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3193c4f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confetti-overlay" }

import ConfettiExplosion from "vue-confetti-explosion";
import {ref} from "vue";
import {ConfettiOptions} from "@/types";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let confettiActive = ref<boolean>(false)
const options: ConfettiOptions = {
  count: 300,
  force: 0.7,
  duration: 6000,
  size: 15,
  colors: ['#F5928C', '#8094CB', '#FBC4A8', '#7F675B', '#CEE6BF', '#AFACD0', '#657377', '#C1E6EB'],
  height: 1400,
  width: 500,
  destory: true
}
let start = (): void => {
  confettiActive.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ConfettiExplosion), {
      particleCount: options.count,
      force: options.force,
      duration: options.duration,
      particleSize: options.size,
      colors: options.colors,
      stageHeight: options.height,
      stageWidth: options.width,
      shouldDestroyAfterDone: options.destory
    }, null, 8, ["particleCount", "force", "duration", "particleSize", "colors", "stageHeight", "stageWidth", "shouldDestroyAfterDone"])
  ]))
}
}

})